import React from 'react';

import { getTrans } from '@/utils/tools';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { TRACKING_TYPE } from '@/utils/constants';
import { TrackerProps } from '@/types/common';
import { InitStoreType } from '@/types/store/init';
import { inject, observer } from 'mobx-react';
import clsx from 'classnames';

import ArrowDown from '@/assets/img/arrow_down_grey.svg';

import './style.scss';

type ChatHistoryPromptProps = {
  initStore: InitStoreType;
  userStore: any;
} & TrackerProps;

function ChatHistoryPrompt(props: ChatHistoryPromptProps) {
  const { passedRef, initStore, userStore } = props;

  const trackingName = TRACKING_TYPE.SCROLL_DOWN_TO_VIEW_HISTORY;
  const trackingData = {
    current_chat_session_id: initStore.sessionId || '0',
    client_rank: userStore?.loyaltyTierCode?.toString() || '',
  };

  return (
    <div
      ref={passedRef}
      data-trackingname={trackingName}
      data-trackingdata={JSON.stringify(trackingData)}
      className={clsx('chat-history-prompt', { 'margin-top': initStore.isIOS })}
    >
      <img className="prompt-icon" src={ArrowDown} />
      <span className="prompt-label">{getTrans('scroll_down_to_view_history')}</span>
    </div>
  );
}

export default tracker(inject(getChildInject('initStore', 'userStore'))(observer(ChatHistoryPrompt)));
